import _stringUtils from '@app/utils/string.utils';

const validate = (values) => {
    const errors = {} as any;
    const { if_customertitle, if_reporttitle, if_companyname } = values;

    if (_stringUtils.isEmpty(if_customertitle)) {
        errors.if_customertitle =
            'Tiêu đề người mua hàng không được để trống !';
    }

    if (_stringUtils.isEmpty(if_reporttitle)) {
        errors.if_reporttitle = 'Tiêu đề mẫu in không được để trống !';
    }

    if (_stringUtils.isEmpty(if_companyname)) {
        errors.if_companyname = 'Tiêu công ty thực phẩm không được để trống !';
    }

    return errors;
};

export default validate;
